import {
  AdminConfirmStep,
  AdminEnrollStep,
  DateFieldMapConfig,
  EnrollmentStepTypeEnrollee,
  EnrollmentStepTypePrerequisites,
  EnrollmentStepTypeTerms,
  EnrollmentStepTypeWorkshops,
  ProfileFieldTypeNumber,
  ProfileFieldTypeSingleLineText,
  ProfileFieldTypeSingleSelectDropdown,
  SortTypeAlphabeticalAscending,
  SortTypeAlphabeticalDescending,
  SortTypeDefault,
  SortTypeDurationAscending,
  SortTypeDurationDescending,
  SortTypeNone,
  SortTypePriceAscending,
  SortTypePriceDescending,
} from "utils/types";

import SettingsEthernetOutlinedIcon from "@mui/icons-material/SettingsEthernetOutlined";
import OpenInFullOutlinedIcon from "@mui/icons-material/OpenInFullOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

export const SORT_DEFAULT: SortTypeDefault = "SORT_DEFAULT";
export const SORT_ALPHABETICAL_ASCENDING: SortTypeAlphabeticalAscending =
  "SORT_ALPHABETICAL_ASCENDING";
export const SORT_ALPHABETICAL_DESCENDING: SortTypeAlphabeticalDescending =
  "SORT_ALPHABETICAL_DESCENDING";
export const SORT_DURATION_ASCENDING: SortTypeDurationAscending = "SORT_DURATION_ASCENDING";
export const SORT_DURATION_DESCENDING: SortTypeDurationDescending = "SORT_DURATION_DESCENDING";
export const SORT_PRICE_ASCENDING: SortTypePriceAscending = "SORT_PRICE_ASCENDING";
export const SORT_PRICE_DESCENDING: SortTypePriceDescending = "SORT_PRICE_DESCENDING";
export const SORT_NONE: SortTypeNone = "SORT_NONE";

export const PROFILE_FIELD_TYPE_SINGLE_LINE_TEXT: ProfileFieldTypeSingleLineText = "SingleLineText";
export const PROFILE_FIELD_TYPE_NUMBER: ProfileFieldTypeNumber = "number";
export const PROFILE_FIELD_TYPE_SINGLE_SELECT_DROPDOWN: ProfileFieldTypeSingleSelectDropdown =
  "SingleSelectDropdown";

export const ENROLLMENT_STEP_WORKSHOPS: EnrollmentStepTypeWorkshops = "WORKSHOPS";
export const ENROLLMENT_STEP_ENROLLEE: EnrollmentStepTypeEnrollee = "ENROLLEE";
export const ENROLLMENT_STEP_TERMS: EnrollmentStepTypeTerms = "TERMS";
export const ENROLLMENT_STEP_PREREQUISITES: EnrollmentStepTypePrerequisites = "PREREQUISITES";

export const ADMIN_ENROLL_STEP: AdminEnrollStep = "ADMIN_ENROLL";
export const ADMIN_CONFIRM_STEP: AdminConfirmStep = "ADMIN_CONFIRM";

export const FILTER_ENROLLED = "Enrolled";
export const FILTER_IN_PROGRESS = "InProgress";
export const FILTER_PROCESSING = "PaymentAwaited";

export const REQUIRED_LEARNING = "Required Learning";
export const COURSES_COMPLETE = "Courses Complete";
export const CERTIFICATIONS_ACQUIRED = "Certifications Acquired";
export const HEADER_CLICK_TYPES = {
  REPORT: "Report",
  LOGOUT: "Logout",
  SERVICENOW: "ServiceNow",
  CONTACTUS: "ContactUs",
  SURVEY: "survey",
  LEARNING_REQUEST: "learningRequest",
};
export const KLP_COURSE_WINDOW_NAME = "KLP_COURSE_WINDOW";
export const KLP_SERVICE_NOW_WINDOW_NAME = "KLP_SERVICE_NOW_WINDOW";

export const TILE_TYPES = {
  MY_LEARNING: "MY_LEARNING",
  POPULAR: "POPULAR",
  RECOMMENDED: "RECOMMENDED",
};
export const ATTENDANCE = "Attendance";

export const EXCEPTIONS_CODES = {
  UnAuthorized: "UnAuthorized",
};

export const SUB_HEADER_CONTENT_TYPE = {
  ATTENDANCE_CONFIRMATION: "ATTENDANCE_CONFIRMATION",
  ACTIVITY_COMPLETION: "ACTIVITY_COMPLETION",
};

export const PERMISSIONS = {
  CAN_VIEW_REPORT: "CanViewReport",
  CAN_MANAGE_ATTENDANCE: "CanManageAttendance",
  CAN_ENROLL_USERS: "CanEnrollUsers",
};

export const ENROLLMENT_DIALOG_TYPES = {
  COURSE: "Course",
  PATHWAY: "Pathway",
  ADMIN: "Admin",
};

export const SESSION_STORAGE_KEYS = {
  LOGOUT_COMPLETE_LABEL: "logout_complete_label",
  LOGOUT_COMPLETE_DIALOG: "logout_complete_dialog",
  LOGIN_BACK: "loginback",
  HERE: "here",
  NOT_AUTHORIZED: "not_authorized",
  NOT_AUTHORIZED_DIALOG: "not_authorized_dialog",
  THEME_COLOR: "theme_name",
  FEATURES: "features",
  APPLICATION_STATE: "application_state",
};

export const AUTH_PROVIDERS = {
  AZURE: "AZURE",
  OPTIMAL: "OPTIMAL",
};

export const TOKENS = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  ID_TOKEN: "ID_TOKEN",
};
export const SKILL_STATUS = {
  COMPLETED: "COMPLETED",
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
};

export const OTHER_REASON = "Other";

export const HeaderMenuIconKey = {
  HEADERMENU: "HeaderMenu",
  PROFILE: "profile",
  BROWSECATALOGUE: "browsecatalogue",
  CALENDAR: "calendar",
  NOTIFICATION: "notification",
  MYLEARNING: "mylearning",
};

export const LINE_MANAGER_EMAIL = "LineManagerEmail";

export const SURVEY_OPTIONS_NEGATIVE_RESPONSE = {
  NeitherAgreeOrDisagree: "Neither agree or disagree",
  StronglyDisagree: "Strongly disagree",
  Disagree: "Disagree",
};

export const MyLearning_Link_Paths = {
  AttendanceConfirmation: "/attendance-confirmation",
  Profile: "/profile",
  MyLearning: "/catalog/MyLearning",
  LearningRequest: "/learningRequest",
};

export const KEY_CODE = {
  ENTER: "ENTER",
  ESCAPE: "ESCAPE",
  ARROWUP: "ARROWUP",
  ARROWDOWN: "ARROWDOWN",
  TAB: "TAB",
  SPACE: " ",
  HOME: "HOME",
  END: "END",
};

export const MenuIcon = {
  "Data and Technology": SettingsEthernetOutlinedIcon,
  "Personal Growth": OpenInFullOutlinedIcon,
  "Workplace Focused": AssignmentOutlinedIcon,
  Management: SettingsEthernetOutlinedIcon,
  Corporate: SettingsEthernetOutlinedIcon,
};

export const ButtonMyLearning = "btnMyLearning";

export const Page = {
  SubjectArea: "subjectarea",
  Subject: "subject",
  Course: "courseView",
};

export const GROUP = {
  PUBLIC: "Public",
  CLOSED_COMMERCIAL_ESTATE: "Closed commercial estate",
  CLOSED_CLIENT_ESTATE: "Closed client estate",
};

export const TYPE_OF_BOOKING = {
  Group: "Group",
  Individual: "Individual",
};

export const VIRTUAL = "Virtual";

export const VENUE = {
  Your_own_venue: "Your own venue",
  Supplier_provides_venue: "Supplier provides venue",
};

export const ELEMENT_ID = {
  SUBJECTAREA: "subject-area",
  SUBJECT: "subject",
  COURSE: "course",
  COURSEDETAILS: "course-details",
  NAME: "name",
  IMAGE: "image",
  DESCRIPTION: "description",
  CODE: "code",
  TAGS: "tags",
  SEARCHRESULTS: "search-results",
  BOOKINGTYPE: "booking-type",
  LEARNINGTYPE: "learning-type",
  VENUE: "venue",
  DELEGATES: "delegates",
  BREADCRUMB: "breadcrumb",
  SUMMARY: "summary",
  DOWNLOADFORMBTN: "download-booking-form",
  ADDTOBASKETBTN: "add-to-basket",
  EXPRESSINTEREST: "express-interest",
  DURATION: "duration",
  PRICE: "price",
  NORESULTS: "no-results",
  ALL: "all",
  COUNT: "count",
  SORT: "sort",
  HEADER: "header",
  LOADMORE: "loadmore",
  VIEWMORE: "viewmore",
  OBJECTIVES: "objectives",
  PREREQUISITES: "prerequisites",
  PAGETEXT: "page-text",
  VIEWCOURSE: "viewcourse",
  VIEWSUBJECT: "viewsubject",
  VIEWSUBJECTAREA: "viewsubjectarea",
  LINK: "link",
  LABEL: "label",
  TEXTBOX: "textbox",
  SEARCHTERM: "search-term",
  QUANTITY: "quantity",
  BASKET: "basket",
  MOBILE: "mobile",
  DATEANDLOCATION: "date-and-location",
  DATE: "date",
  DATETYPE: "date-type",
  LOCATION: "location",
  TIME: "time",
  ROOM: "room",
  ADDRESS: "address",
  CARD: "card",
  CONTINUE: "continue",
  BACK: "back",
  COMPLETE: "complete",
  ICON: "icon",
  STEPPER: "stepper",
  BASKETCONTENT: "basket-content",
  COURSEID: "course-id",
  PROCEEDTOCHECKOUT: "proceedtocheckout",
  CONTINUESHOPPING: "continueShopping",
  TOTAL: "total",
  HOSTANDDELEGATE: "host-and-delegate",
  HOST: "host",
  DELEGATE: "delegate",
  FIRSTNAME: "first-name",
  LASTNAME: "last-name",
  EMAILADDRESS: "email-address",
  PHONENUMBER: "phone-number",
  PAYMENT: "payment",
  PONUMBER: "po-number",
  COSTCENTER: "cost-centre",
  PAYMENTAPPROVALID: "payment-approval-id",
  BUSINESSUNIT: "business-unit",
  COUNTRY: "country",
  BUSINESSAREA: "business-area",
  EVENTNOTES: "event-notes",
  REVIEW: "review",
  DELETE: "delete",
  ADD: "add",
  REMOVE: "remove",
  MYBOOKINGS: "myBookings",
  DEADLINEDATE: "deadline-date",
  DEADLINETIME: "deadline-time",
  FROMDATERANGE: "from-date-range",
  TODATERANGE: "to-date-range",
  PREFERREDMONTH: "preferred-month",
  COURSE_NOT_AVAILABLE: "course-not-available",
  PREFERREDDATE: "preferred-date",
  HIDEALTERNATIVEDATES: "hide-alternative-dates",
};
export const ErrorMessages = {
  InputRequired: "field cannot be left blank",
  InvalidEmail: "Email is invalid",
  MinQty: "Quantity field required with minimum 1 value",
};

export const IBF_ENABLED = "ibfenabled";

export const BookingJourney_Paths = {
  BookingJourney: "/bookingJourney",
  Summary: "/bookingJourney/summary",
};
export const Component = {
  ErrorMessageId: "error-message-",
  Star: "*",
};
export const DATE_FORMAT = {
  ddMMyyyy: "dd/MM/yyyy",
  MMMMyyyy: "MMMM yyyy",
  MMMMYYYY: "MMMM yyyy",
  ddddDMMMMyyyy: "EEEE d MMMM yyyy",
  EEEMMMddyyyy: "EEE MMM dd yyyy",
};
export const ACTION_STATUS_MESSAGE = {
  Success: "success",
};

export const BOOKING_JOURNEY = "bookingJourney";

export const COUNTRIES = {
  UK: "United Kingdom",
};

export const EVENTSTEXT = "Events";

export const OFF_THE_SHELF_PRODUCT = "Off-the-shelf product";

export const HELP_TEXT = `Due date. Use Alt+Down Arrow to Open the popup and moves the focus to the displayed calendar.
                        Use Alt+Up Arrow	to close the popup and moves the focus to the input element. Use Esc to close the popup and moves the focus to the input element.`;

export const DDL_HELP_TEXT = `Use Alt+Down Arrow to Open the drop down and moves the focus to the displayed drop down list.
                        Use Esc to close the popup and moves the focus to the input element.`;

export const DATE_PICKER_FORMAT = "dd MMM yy";

export const MY_LEARNING_KEYS = {
  PROFILE: "profile",
  MY_LEARNING: "myLearning",
  MY_BOOKINGS: "myBookings",
  NOTIFICATIONS: "notifications",
  INCIDENT_MGMT: "incidentMgmt",
  MANAGE_ATTENDANCE: "manageAttendance",
  CONTACT_US: "contactUs",
  LOGOUT: "logout",
  LEARNING_REQUEST: "learningRequest",
};
export const DEFAULT_CURRENCY = "GBP";
export const JSON_PROPERTY = {
  MARKUP: "markup",
};
export const ProductDetailsFields = {
  Date: "date",
  DeadlineDate: "deadlineDate",
  VenueId: "venueId",
  ModificationStatus: "modificationStatus",
  FromDateRange: "fromDateRange",
  ToDateRange: "toDateRange",
  DateType: "dateType",
  Location: "location",
  PreferredStartTime: "preferredStartTime",
  PreferredMonth: "preferredMonth",
  PreferredDate: "preferredDate",
  RoomNumber: "roomNumber",
  Address: "address",
  EventNotes: "eventNotes",
};

export const DateTypeOptionIds = {
  PreferredDate: "PrefDate",
  DeadlineDate: "Deadline",
  DateRange: "DateRange",
  PreferredMonth: "PrefMonth",
};

export enum CostCentreInputType {
  Freetext = "freetext",
  Dropdown = "dropdown",
}

export const DateFieldMap: DateFieldMapConfig = {
  [DateTypeOptionIds.PreferredDate]: {
    dateTypeFieldConfig: [
      {
        label: "course_date",
        field: ProductDetailsFields.Date,
        elementId: ELEMENT_ID.DATE,
        ariaLabelId: ELEMENT_ID.DATETYPE,
        rootClass: "marginTop",
        errorMessageLabel: "preferred-date",
      },
    ],
    bookingJourneyGridLabel: "preferred-date",
  },
  [DateTypeOptionIds.DeadlineDate]: {
    dateTypeFieldConfig: [
      {
        label: "course_date",
        field: ProductDetailsFields.DeadlineDate,
        elementId: ELEMENT_ID.DEADLINEDATE,
        ariaLabelId: ELEMENT_ID.DATETYPE,
        rootClass: "marginTop",
        errorMessageLabel: "deadline-date",
      },
    ],
    bookingJourneyGridLabel: "deadline-date",
  },
  [DateTypeOptionIds.PreferredMonth]: {
    dateTypeFieldConfig: [
      {
        field: ProductDetailsFields.PreferredMonth,
        elementId: ELEMENT_ID.PREFERREDMONTH,
        ariaLabelId: ELEMENT_ID.PREFERREDMONTH,
        label: "preferred-month",
        isMonth: true,
        showLabel: true,
      },
    ],
    bookingJourneyGridLabel: "preferred-month",
  },
  [DateTypeOptionIds.DateRange]: {
    dateTypeFieldConfig: [
      {
        field: ProductDetailsFields.FromDateRange,
        label: "daterange-from",
        elementId: ELEMENT_ID.FROMDATERANGE,
        ariaLabelId: ELEMENT_ID.FROMDATERANGE,
        showLabel: true,
      },
      {
        field: ProductDetailsFields.ToDateRange,
        label: "daterange-to",
        elementId: ELEMENT_ID.TODATERANGE,
        ariaLabelId: ELEMENT_ID.TODATERANGE,
        showLabel: true,
      },
    ],
    bookingJourneyGridLabel: "daterange",
  },
};
